import React from "react";
import { FormInput } from "../form";

const Stock = ({ values, errors, handleChange, ...Props }) => {
  return (
    <div className="rounded-[8px] border-[1px] border-[#DCDCDC] p-3 sm:p-4">
      <p className="mb-[0.94rem] text-[1.5rem] font-bold text-[#1F1F1F]">
        Stock & Inventory
      </p>
      <p className="text-[0.75rem] font-normal text-[#525252]">
        To start selling, all you need is a name, price and image
      </p>
      <p className="mb-[0.94rem] mt-[3.25rem] text-[0.875rem] font-bold text-[#1F1F1F]">
        General
      </p>
      <p className="mt-[0.94rem] max-w-[22.5rem] text-[0.75rem] font-normal text-[#525252]">
        Give your product a short and clear name. 50-60 characters is the
        recommended length for search engines.
      </p>
      <div className="mb-[1.88rem] mt-[2.25rem] grid items-start gap-6 sm:grid-cols-2">
        <FormInput
          id="productSKU"
          name="productSKU"
          value={values.productSKU}
          placeholder="SUN-G, JK1234..."
          error={Boolean(errors.productSKU)}
          onChange={handleChange}
          label="Store Keeping Unit (SKU)"
          errorMsg={errors.productSKU}
          isRequired
        />
        <FormInput
          id="productQuantity"
          name="productQuantity"
          value={values.productQuantity}
          placeholder="100"
          error={Boolean(errors.productQuantity)}
          onChange={handleChange}
          label="Quantity in Stock"
          errorMsg={errors.productQuantity}
        />
      </div>

      {/* <div className="flex mt-[1.53rem] mb-[2.47rem] gap-[4rem]">
        <label className="font-medium text-[0.75rem] text-[#525252]">
          <input
            type="checkbox"
            className="mr-[10px] text-[#0FAA8E] rounded-[5px]"
          />
          Manage Inventory
          <span className="checkmark"></span>
          <WarningIcon className="inline ml-[5px] mb-[2px] w-[0.75rem] h-[0.75rem]" />
        </label>
        <label className="font-medium text-[0.75rem] text-[#525252]">
          <input
            type="checkbox"
            className="mr-[10px] text-[#0FAA8E] rounded-[5px]"
          />
          Allow Backorders
          <WarningIcon className="inline ml-[5px] mb-[2px] w-[0.75rem] h-[0.75rem]" />
          <span className="checkmark"></span>
        </label>
      </div> */}
    </div>
  );
};

export default Stock;
